var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offline-page"},[_c('div',[_vm._v("Content not avalaible!")]),_c('div',{domProps:{"textContent":_vm._s(_vm.error)}})])}
var staticRenderFns = []

export { render, staticRenderFns }